<script>
import iframeResize from 'iframe-resizer/js/iframeResizer';
import Fragment from '@phoenix/components/common/Fragment';

export default {
  components: {
    Fragment,
  },

  directives: {
    resize: {
      created(el, { value: options = {} }) {
        options = {
          minHeight: '50vh',
          ...options,
        };

        el.addEventListener('load', () => iframeResize(options, el));
      },
      unmounted(el) {
        el.iFrameResizer.removeListeners();
      },
    },
  },

  props: {
    id: {
      type: String,
      required: true,
    },
    url: {
      type: String,
      required: true,
    },
    hasContainer: {
      type: Boolean,
      default: false,
    },
    shouldForwardParams: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      countryCode: window.Phoenix.currentCountry,
      languageCode: window.Phoenix.laravelLanguage,
      localisationCode: window.Phoenix.localisationUrlPrefix,
      urlWithParams: this.url,
    };
  },

  computed: {
    iframeUrl() {
      return this.urlWithParams
        .toString()
        .replace('{country}', this.countryCode.toLowerCase())
        .replace('{language}', this.languageCode.toLowerCase())
        .replace('{locale}', this.localisationCode.toLowerCase())
        .replace('{legacy_locale}', this.localisationCode.toLowerCase().replace('-', '/'));
    },

    currentComponent() {
      return this.hasContainer ? 'div' : Fragment;
    },
  },

  created() {
    if (this.shouldForwardParams) {
      const urlParams = new URLSearchParams(window.location.search);
      const urlWithParams = new URL(this.url);
      for (const [key, value] of urlParams) {
        urlWithParams.searchParams.append(key, value);
      }

      this.urlWithParams = urlWithParams.href;
    }
  },
};
</script>

<template>
  <component :is="currentComponent" :class="{ container: hasContainer }">
    <iframe
      :id="id"
      v-resize="{ log: false }"
      data-cy="advanced-iframe"
      :src="iframeUrl"
      width="100%"
      style="border: none; width: 100%"
    ></iframe>
  </component>
</template>
